"use strict";

module.exports = function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.bind('click', function() {
        var message = attrs.confirm;
        if (message && confirm(message)) {
          scope.$apply(attrs.action);
        }
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/confirm.js